import React from 'react';

import {
  BarChart3,
  Bell,
  BookOpenText,
  Files,
  FileText,
  GitBranch,
  Globe,
  Home,
  LayoutDashboard,
  Rocket,
  Settings,
  Users,
} from 'lucide-react';
import { AIChatIcon } from 'src/components/icons/AIChatIcon';

import type { TabType } from './tab-types';
import { TAB_TYPES } from './tab-types';

interface TabIconProps {
  type: TabType;
}

export function TabIcon({ type }: TabIconProps): JSX.Element {
  switch (type) {
    case TAB_TYPES.home:
    case TAB_TYPES.chat:
      return <Home size={18} strokeWidth={1.5} />;
    case TAB_TYPES.dashboard:
      return <LayoutDashboard size={18} strokeWidth={1.5} />;
    case TAB_TYPES.workflows:
    case TAB_TYPES.workflowDetail:
      return <GitBranch size={18} strokeWidth={1.5} />;
    case TAB_TYPES.templates:
      return <Files size={18} strokeWidth={1.5} />;
    case TAB_TYPES.documents:
    case TAB_TYPES.documentEditor:
      return <FileText size={18} strokeWidth={1.5} />;
    case TAB_TYPES.parties:
      return <Users size={18} strokeWidth={1.5} />;
    case TAB_TYPES.reports:
      return <BarChart3 size={18} strokeWidth={1.5} />;
    case TAB_TYPES.playbooks:
      return <BookOpenText size={18} strokeWidth={1.5} />;
    case TAB_TYPES.reminders:
      return <Bell size={18} strokeWidth={1.5} />;
    case TAB_TYPES.admin:
      return <Settings size={18} strokeWidth={1.5} />;
    case TAB_TYPES.community:
      return <Globe size={18} strokeWidth={1.5} />;
    case TAB_TYPES.getStarted:
      return <Rocket size={18} strokeWidth={1.5} />;
    default:
      return <AIChatIcon height={18} strokeWidth={1.5} width={18} />;
  }
}
